export const getTrailerExperimentValueLastRodeo = (value: string) => {
  if (value === 'video-2') return 'i-25KRuJmRQ'
  if (value === 'video-3') return 'q6NW2Cj8ZqI'
  if (value === 'video-4') return '3RVDGCcu25Q'

  return '8dC_GBIosa4'
}
